import React from "react";
import {Trans, useTranslation} from "react-i18next";
import {Link, LinkColors} from "pu-crossproduct-components/build/components/Molecules/Navigation/Link";
import {Body3} from "pu-crossproduct-components/build/components/Atoms/Type";
import {LogoutUrl} from "../../../../routing/InformatExternalLinks/InformatExternalLinks";


export interface IProps {
    userFirstName: string
}

export const NotPerson : React.FC<IProps> = props => {
    const { t } = useTranslation();

    return <Body3><Trans t={t} values={{ userFirstName: props.userFirstName }} components={{logoutLink: <Link href={LogoutUrl} color={LinkColors.type} />}}>twoFactorInformatAccountPickerNotUserLink</Trans></Body3>
}
